export default {
  common: {
    noData: "暂无数据",
    noSearchData: "搜索无结果",
    resend: "重发",
    confirm: "确定",
    cancel: "取消",
    sort: "排序",
    createdAt: "创建时间",
    updatedAt: "修改时间",
    name: "名称",
    nickName: "昵称",
    size: "大小",
    type: "类型",
    source: "来源",
    endTime: "到期时间",
    handle: "操作",
    fileList: "文件列表",
    model: "型号",
    customerService: "客服",
    send: "发送",
    save: "保存",
    modify: "修改",
    phone: "手机",
    email: "邮箱",
    code: "验证码",
    wechat: "微信",
    image: "图片",
    audio: "音频",
    folder: "文件夹",
    note: "笔记",
    prompt: "提示",
    copy: "复制",
    sms: "短信",
    password: "密码",
    oldVersion: "旧版",
    newVersion: "新版",
    upload: "上传",
    downloading: "下载中",
    uploading: "正在上传中",
    check: "查询",
  },

  router: {},

  tooltip: {},

  placeholder: {
    phone: "请输入手机",
    email: "请输入邮箱",
    code: "请输入验证码",
    name: "请输入名称",
    website: "请输入网址",
    img: "选择图片",
    search: "请输入搜索内容",
    content: "请输入内容",
  },

  alert: {},

  elMsg: {
    phoneEmpty: "手机不能为空或带有空格",
    areaEmpty: "区号不能为空",
    emailEmpty: "邮箱不能为空或带有空格",
    codeEmpty: "验证码不能为空或带有空格",
    contentEmpty: "不能发送空消息",
    nameEmpty: "名称不能为空",
    nameSame: "此文件夹内，您已有相同名称的笔记",
    emailError: "邮箱格式有误",
    max80: "不能超过80个字符",
    delSuccess: "删除成功",
    delFailure: "删除失败",
    copySuccess: "复制成功",
    copyFailure: "复制失败",
    cancelSuccess: "取消成功",
    favoriteSuccess: "收藏成功",
    restoreSuccess: "恢复成功",
    pushSuccess: "推送成功",
    createSuccess: "创建成功",
    moveSuccess: "移动成功",
    unbindSuccess: "解绑成功",
    modifySuccess: "修改成功",
    bindSuccess: "绑定成功",
    checkSuccess: "查询成功",
    getSuccess: "领取成功",
    sendSuccess: "发送成功",
    selectFile: "请勾选文件",
    tips1: "您的云盘空间不足，请清理后再试",
    tips2: "文件大小不能大于200M",
    tips3: "请选择要操作的文件",
    tips4: "请上传格式为JPG、JPEG、PNG的图片",
    tips5: "请输入有效的网址",
    tips6: "请选择文件夹",
    tips7: "图片不能大于3MB",
    tips8: "请选择需要上传图片",
    tips9: "验证码只能输入数字",
    tips10: "该手机已绑定其他用户，不可再绑定",
    tips11: "手机绑定成功",
    tips12: "该邮箱已绑定其他用户，不可再绑定",
    tips13: "邮箱绑定成功",
    tips14: "账号登录已过期，请重新登录",
    tips15: "文件大小超过%{size}限制",
    tips16: "无绑定设备，请从设备端进行绑定",
    tips17: "该账号已存在主账号，不可关联",
    tips18: "已复制领取码到剪贴板",
    tips19: "请勾选需要下载的音频",
    tips20: "如该号码收不到验证码，请与商家联系确定手机号",
  },

  login: {
    logout: "退出",
    login: "登录",
    phoneLogin: "手机登录",
    emailLogin: "邮箱登录",
    scanLogin: "扫码登录",
    scanTips1: "打开BOOX助手App",
    scanTips2: "在「我的」页面顶部打开扫一扫",
    scanTips3: "二维码过期，请重新扫描",
    getCode: "获取验证码",
    agree: "同意",
    privacy: "隐私政策",
    agreement: "用户协议",
    autoLogin: "一个月内自动登录",
  },
};
